<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import './base.css'

export default {
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue